(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["430-how-it-wor"] && !Shopify.designMode) return;
  try {
    
class HowItWorksTabs {
  constructor(section) {
    this.section = section;
    this.tabButtons = section.querySelectorAll('.how-it-works__tab-btn');
    this.panels = section.querySelectorAll('.how-it-works__panel');
    this.init();
  }

  init() {
    this.tabButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const target = e.currentTarget.dataset.tab;
        this.switchTab(target);
      });
    });
  }

  switchTab(tabId) {
    // Update buttons
    this.tabButtons.forEach(btn => {
      btn.classList.toggle('active', btn.dataset.tab === tabId);
      btn.setAttribute('aria-selected', btn.dataset.tab === tabId);
    });

    // Update panels
    this.panels.forEach(panel => {
      panel.classList.toggle('active', panel.dataset.tab === tabId);
    });
  }
}

// Initialize all instances
document.querySelectorAll('.how-it-works').forEach(section => {
  if (!section.dataset.tabsLoaded) {
    new HowItWorksTabs(section);
    section.dataset.tabsLoaded = 'true';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["622-light-show"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var selector = '[data-vhlt-section][data-vhlt-version="3.0-reference"]';
  var managerKey = '__vhLightModesReferenceV3';
  if (window[managerKey]) {
    window[managerKey].initAll(document);
    return;
  }
  var instances = new WeakMap();

  function init(root) {
    if (!root || instances.has(root)) return;
    var abort = new AbortController();
    var panels = Array.from(root.querySelectorAll('[data-vhlt-panel]'));
    var triggers = Array.from(root.querySelectorAll('[data-vhlt-trigger]'));
    var images = Array.from(root.querySelectorAll('[data-vhlt-image-index]'));
    var stories = Array.from(root.querySelectorAll('[data-vhlt-story-index]'));
    var featured = root.querySelector('[data-vhlt-featured]');
    var toggle = root.querySelector('[data-vhlt-cards-toggle]');
    var visibleCount = Number(root.dataset.vhltVisibleCards) || 3;

    function syncToggle() {
      if (!toggle) return;
      var expanded = root.dataset.vhltMobileCardsExpanded === 'true';
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.textContent = expanded ? (toggle.dataset.collapseText || 'Show less') : (toggle.dataset.expandText || 'Show all');
    }
    function revealSelected(index) {
      if (toggle && Number(index) >= visibleCount) {
        root.dataset.vhltMobileCardsExpanded = 'true';
        syncToggle();
      }
    }
    function promoteImage(parent) {
      if (!parent) return;
      parent.querySelectorAll('img[loading="lazy"]').forEach(function (image) {
        // Only the selected mode is promoted. No parallel high-priority requests.
        image.loading = 'eager';
      });
    }
    function revealHorizontally(trigger) {
      if (!trigger) return;
      var track = trigger.closest('.vhlt__tabs, .vhlt__cards');
      if (!track || track.scrollWidth <= track.clientWidth + 2) return;
      var trackRect = track.getBoundingClientRect();
      var buttonRect = trigger.getBoundingClientRect();
      var delta = buttonRect.left < trackRect.left ? buttonRect.left - trackRect.left :
        (buttonRect.right > trackRect.right ? buttonRect.right - trackRect.right : 0);
      if (delta) track.scrollBy({left: delta, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    function activate(index, options) {
      options = options || {};
      var key = String(index);
      var activePanel = panels.find(function (panel) { return panel.dataset.vhltIndex === key; });
      if (!activePanel) return false;
      root.dataset.vhltActiveIndex = key;
      triggers.forEach(function (trigger) {
        var selected = trigger.dataset.vhltIndex === key;
        trigger.classList.toggle('is-active', selected);
        if (trigger.getAttribute('role') === 'tab') {
          trigger.setAttribute('aria-selected', String(selected));
          trigger.tabIndex = selected ? 0 : -1;
        } else {
          trigger.setAttribute('aria-pressed', String(selected));
        }
      });
      panels.forEach(function (panel) {
        var selected = panel === activePanel;
        panel.classList.toggle('is-active', selected);
        panel.hidden = !selected;
      });
      if (featured) {
        featured.style.setProperty('--active-color', activePanel.dataset.vhltColor || '');
        featured.classList.toggle('has-bg-active', activePanel.dataset.vhltHasBg === 'true');
      }
      images.forEach(function (image) {
        var selected = image.dataset.vhltImageIndex === key;
        image.classList.toggle('is-active', selected);
        image.hidden = !selected;
        if (selected) {
          root.style.setProperty('--vhlt-active-ratio-desktop', image.dataset.vhltRatioDesktop || '1');
          root.style.setProperty('--vhlt-active-ratio-mobile', image.dataset.vhltRatioMobile || '1');
          if (!options.initial) promoteImage(image);
        }
      });
      stories.forEach(function (story) {
        var selected = story.dataset.vhltStoryIndex === key;
        story.classList.toggle('is-active', selected);
        story.hidden = !selected;
      });
      if (!options.initial) promoteImage(activePanel);
      if (options.reveal) revealSelected(key);
      if (options.focus && options.focus.isConnected) {
        options.focus.focus({preventScroll: true});
        revealHorizontally(options.focus);
      }
      return true;
    }

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-vhlt-trigger]');
      if (trigger && root.contains(trigger)) {
        activate(trigger.dataset.vhltIndex, {reveal: true});
        return;
      }
      var toggleTarget = event.target.closest('[data-vhlt-cards-toggle]');
      if (toggleTarget && toggleTarget === toggle) {
        var willExpand = root.dataset.vhltMobileCardsExpanded !== 'true';
        root.dataset.vhltMobileCardsExpanded = String(willExpand);
        // Do not leave the only keyboard-focusable tab in a hidden collapsed row.
        if (!willExpand && !root.querySelector('.vhlt__tabs') && Number(root.dataset.vhltActiveIndex) >= visibleCount) activate('0');
        syncToggle();
      }
    }, {signal: abort.signal});

    root.addEventListener('keydown', function (event) {
      var trigger = event.target.closest('[data-vhlt-trigger][role="tab"]');
      if (!trigger || !root.contains(trigger)) return;
      var allowed = ['ArrowRight','ArrowLeft','ArrowDown','ArrowUp','Home','End'];
      if (allowed.indexOf(event.key) < 0) return;
      var group = trigger.closest('[role="tablist"]');
      if (!group) return;
      var groupTabs = Array.from(group.querySelectorAll('[data-vhlt-trigger][role="tab"]'));
      var current = groupTabs.indexOf(trigger);
      if (current < 0 || !groupTabs.length) return;
      var next = current;
      var verticalStep = 1;
      if (group.classList.contains('vhlt__cards') && getComputedStyle(group).display === 'grid') {
        verticalStep = getComputedStyle(group).gridTemplateColumns.trim().split(/\s+/).length;
      }
      if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = groupTabs.length - 1;
      else if (event.key === 'ArrowRight') next += 1;
      else if (event.key === 'ArrowLeft') next -= 1;
      else if (event.key === 'ArrowDown') next += verticalStep;
      else if (event.key === 'ArrowUp') next -= verticalStep;
      next = (next + groupTabs.length) % groupTabs.length;
      event.preventDefault();
      activate(groupTabs[next].dataset.vhltIndex, {focus: groupTabs[next], reveal: true});
    }, {signal: abort.signal});

    root.vhltActivate = function (index, focusTrigger) {
      var focus = focusTrigger ? triggers.find(function (trigger) {
        return trigger.dataset.vhltIndex === String(index) && trigger.getAttribute('role') === 'tab';
      }) : null;
      return activate(index, {reveal: true, focus: focus});
    };
    root.dataset.vhltReady = 'true';
    var initialIndex = root.dataset.vhltActiveIndex || '0';
    if (!activate(initialIndex, {initial: true})) activate('0', {initial: true});
    syncToggle();
    instances.set(root, {
      destroy: function () {
        abort.abort();
        delete root.vhltActivate;
        delete root.dataset.vhltReady;
        instances.delete(root);
      },
      activate: activate
    });
  }
  function rootsWithin(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches(selector)) roots.push(scope);
    if (scope && scope.querySelectorAll) roots.push.apply(roots, scope.querySelectorAll(selector));
    return roots;
  }
  function initAll(scope) { rootsWithin(scope || document).forEach(init); }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    rootsWithin(event.target).forEach(function (root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
    });
  });
  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    var root = target && target.closest ? target.closest(selector) : null;
    var candidates = root ? [root] : rootsWithin(target);
    if (!candidates.length && event.detail && event.detail.blockId) candidates = rootsWithin(document);
    candidates.forEach(function (candidate) {
      init(candidate);
      var blockId = event.detail && event.detail.blockId;
      var panel = Array.from(candidate.querySelectorAll('[data-vhlt-panel]')).find(function (item) {
        return blockId ? item.dataset.vhltBlockId === blockId : (item === target || item.contains(target));
      });
      if (panel) instances.get(candidate).activate(panel.dataset.vhltIndex, {reveal: true});
    });
  });
  window[managerKey] = {initAll: initAll};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () {initAll(document);}, {once:true});
  else initAll(document);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["915-vh-4points"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // Static bundled JavaScript: settings are read from each section's data attributes.
  // No dependency on the filename; multiple copies of this section remain independent.
  var registryKey = '__vhBuyingCriteriaCarouselV11';
  if (window[registryKey]) {
    window[registryKey].init(document);
    return;
  }

  var rootSelector = '[data-vh-bc-section]';
  var instances = new WeakMap();

  function rootsWithin(scope) {
    var roots = [];
    if (scope && scope.nodeType === 1 && scope.matches(rootSelector)) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll(rootSelector)));
    }
    return roots;
  }

  function createInstance(root) {
    if (instances.has(root)) return;
    var track = root.querySelector('[data-vh-bc-track]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-vh-bc-card]'));
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-vh-bc-slide]'));
    if (!cards.length) return;

    var navigation = root.querySelector('[data-vh-bc-navigation]');
    var previous = root.querySelector('[data-vh-bc-prev]');
    var next = root.querySelector('[data-vh-bc-next]');
    var status = root.querySelector('[data-vh-bc-status]');
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var frame = 0;
    var destroyed = false;
    var removers = [];
    var resizeObserver = null;
    var lastActive = null;

    function listen(target, eventName, callback, options) {
      target.addEventListener(eventName, callback, options);
      removers.push(function () { target.removeEventListener(eventName, callback, options); });
    }

    function isActive() {
      return mobileQuery.matches && root.dataset.vhBcLayout === 'carousel';
    }

    function perView() {
      var value = parseInt(root.dataset.vhBcPerView, 10) || 2;
      return Math.max(1, Math.min(2, value, cards.length));
    }

    function isRtl() { return window.getComputedStyle(track).direction === 'rtl'; }

    function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }

    function offset() {
      // Clamp elastic over-scroll on touch browsers and support RTL's negative scrollLeft.
      return Math.min(maxScroll(), Math.max(0, isRtl() ? -track.scrollLeft : track.scrollLeft));
    }

    function step() {
      var slide = slides[0];
      return slide ? slide.getBoundingClientRect().width + 16 : cards[0].getBoundingClientRect().width;
    }

    function scrollToOffset(value, animate) {
      var target = Math.max(0, Math.min(maxScroll(), value));
      track.scrollTo({
        left: isRtl() ? -target : target,
        behavior: animate && !reduceMotion.matches ? 'smooth' : 'instant'
      });
    }

    function update() {
      frame = 0;
      if (destroyed) return;
      var active = isActive();
      var overflow = active && maxScroll() > 2;
      var position = offset();
      var cardStep = step();
      var pageSize = perView();

      if (active !== lastActive) {
        if (!active) scrollToOffset(0, false);
        lastActive = active;
      }
      track.tabIndex = overflow ? 0 : -1;
      track.setAttribute('aria-label', overflow ? 'Buying criteria. Swipe sideways to read all cards.' : 'Buying criteria');
      if (navigation) navigation.hidden = !overflow || root.dataset.vhBcShowNavigation === 'false';
      if (previous) previous.disabled = !overflow || position <= 2;
      if (next) next.disabled = !overflow || position >= maxScroll() - 2;

      var slideIndex = cardStep > 0 ? Math.round(position / cardStep) : 0;
      slideIndex = Math.max(0, Math.min(slides.length - 1, slideIndex));
      var first = slideIndex * 2 + 1;
      var last = Math.min(cards.length, first + 1);
      var message = first === last ? first + ' / ' + cards.length : first + '\u2013' + last + ' / ' + cards.length;
      if (status && status.textContent !== message) status.textContent = message;
    }

    function scheduleUpdate() {
      if (!frame && !destroyed) frame = window.requestAnimationFrame(update);
    }

    function move(direction) {
      if (!isActive()) return;
      var cardStep = step();
      if (!(cardStep > 0)) return;
      var slideIndex = Math.round(offset() / cardStep);
      scrollToOffset((slideIndex + direction) * cardStep, true);
    }

    function revealCard(card) {
      if (!isActive()) return;
      var index = cards.indexOf(card);
      if (index < 0) return;
      var viewport = track.getBoundingClientRect();
      var cardRect = card.getBoundingClientRect();
      if (cardRect.left >= viewport.left - 1 && cardRect.right <= viewport.right + 1) return;
      scrollToOffset(index * step(), false);
      scheduleUpdate();
    }

    if (previous) listen(previous, 'click', function () { move(-1); });
    if (next) listen(next, 'click', function () { move(1); });
    listen(track, 'scroll', scheduleUpdate, { passive: true });
    listen(window, 'resize', scheduleUpdate, { passive: true });
    listen(track, 'keydown', function (event) {
      if (!isActive() || event.target !== track || event.altKey || event.ctrlKey || event.metaKey) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        move(isRtl() ? -direction : direction);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        scrollToOffset(event.key === 'Home' ? 0 : maxScroll(), true);
      }
    });
    // Keep any links inside a merchant's rich text visible while tabbing through cards.
    listen(track, 'focusin', function (event) {
      if (event.target === track || !(event.target instanceof Element)) return;
      revealCard(event.target.closest('[data-vh-bc-card]'));
    });

    if (mobileQuery.addEventListener) {
      listen(mobileQuery, 'change', scheduleUpdate);
    } else {
      mobileQuery.addListener(scheduleUpdate);
      removers.push(function () { mobileQuery.removeListener(scheduleUpdate); });
    }
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(scheduleUpdate);
      resizeObserver.observe(track);
    }

    instances.set(root, {
      reveal: revealCard,
      refresh: scheduleUpdate,
      destroy: function () {
        destroyed = true;
        if (frame) window.cancelAnimationFrame(frame);
        if (resizeObserver) resizeObserver.disconnect();
        removers.forEach(function (remove) { remove(); });
        if (navigation) navigation.hidden = true;
        track.tabIndex = -1;
        instances.delete(root);
      }
    });
    update();
  }

  function init(scope) { rootsWithin(scope).forEach(createInstance); }
  function destroy(scope) {
    rootsWithin(scope).forEach(function (root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
    });
  }
  window[registryKey] = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    destroy(event.target);
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    if (!(event.target instanceof Element)) return;
    var root = event.target.closest(rootSelector);
    if (!root) return;
    createInstance(root);
    var card = event.target.closest('[data-vh-bc-card]');
    if (!card && event.detail && event.detail.blockId) {
      card = Array.prototype.find.call(root.querySelectorAll('[data-vh-bc-card]'), function (item) {
        return item.dataset.vhBcBlockId === String(event.detail.blockId);
      });
    }
    var instance = instances.get(root);
    if (instance && card) instance.reveal(card);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["917-vh-technology-showcase"] && !Shopify.designMode) return;
  try {
    
/* v2.11 Mixed Tabs: Collection tabs + Product tabs + scene-fit + recommendation carousel + LCP-safe initial render.
   No cart mutations, external libraries, automatic rotation or document scrolling. */
(() => {
  if (customElements.get('vh-cshow-shop-v211')) return;

  class VHCollectionShop extends HTMLElement {
    connectedCallback() {
      this.teardown();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.boundTracks = new WeakSet();
      this.desktopQuery = window.matchMedia('(min-width: 990px)');

      if ('ResizeObserver' in window) {
        this.sceneResizeObserver = new ResizeObserver(() => {
          this.queueSceneFit();
          this.queueRecommendationLayout();
        });
        this.layoutResizeObserver = new ResizeObserver(() => this.queueRecommendationLayout());
      }

      this.addEventListener('load', () => {
        this.queueSceneFit();
        this.queueRecommendationLayout();
      }, { ...options, capture: true });

      window.addEventListener('resize', () => {
        this.queueSceneFit();
        this.queueRecommendationLayout();
      }, options);

      if (this.desktopQuery.addEventListener) {
        this.desktopQuery.addEventListener('change', () => this.queueRecommendationLayout(), options);
      }

      const sceneSignal = this.controller.signal;
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          if (!sceneSignal.aborted && this.isConnected) {
            this.queueSceneFit();
            this.queueRecommendationLayout();
          }
        });
      }

      this.addEventListener('click', (event) => {
        const tabButton = event.target.closest('[data-vhc-tab]');
        if (tabButton && this.contains(tabButton)) {
          this.select(tabButton.dataset.vhcTab);
          return;
        }

        const previous = event.target.closest('[data-vhc-products-prev]');
        if (previous && this.contains(previous)) {
          this.moveRecommendation(previous.closest('[data-vhc-panel]'), -1);
          return;
        }

        const next = event.target.closest('[data-vhc-products-next]');
        if (next && this.contains(next)) {
          this.moveRecommendation(next.closest('[data-vhc-panel]'), 1);
        }
      }, options);

      this.addEventListener('keydown', (event) => this.onKeydown(event), options);

      document.addEventListener('shopify:block:select', (event) => {
        if (!this.contains(event.target)) return;
        const panel =
          event.target.closest('[data-vhc-panel-ready]') ||
          this.panels?.find((item) => item.dataset.blockId === String(event.detail?.blockId));
        if (panel) this.select(panel.id);
      }, options);

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) this.initialize();
      }, options);

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(this)) this.teardown();
      }, options);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { ...options, once: true });
      }

      this.observer = new MutationObserver((changes) => {
        if (changes.some((change) => change.target !== this.tabs && !this.tabs?.contains(change.target))) {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.initialize());
        }
      });
      this.observer.observe(this, { childList: true, subtree: true });
      this.initialize();
    }

    disconnectedCallback() {
      this.teardown();
    }

    teardown() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.sceneResizeObserver?.disconnect();
      this.layoutResizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.sceneFitFrame);
      cancelAnimationFrame(this.recommendationFrame);
      this.sceneFitFrame = 0;
      this.recommendationFrame = 0;
    }

    initialize() {
      this.tabs = this.querySelector('[data-vhc-tabs]');
      if (!this.tabs) return;

      const previousPanels = this.panels;
      this.panels = [...this.querySelectorAll('[data-vhc-panel-ready]')];
      const signature = this.panels.map((panel) => `${panel.id}:${panel.dataset.categoryLabel}`).join('|');
      const sameNodes =
        previousPanels?.length === this.panels.length &&
        this.panels.every((panel, index) => panel === previousPanels[index]);

      this.observeSceneSizes();
      this.bindRecommendationTracks();
      this.observeRecommendationSizes();

      if (sameNodes && this.signature === signature && this.tabs.children.length === this.panels.length) {
        this.queueSceneFit();
        this.queueRecommendationLayout();
        return;
      }

      this.signature = signature;
      const fragment = document.createDocumentFragment();

      this.panels.forEach((panel) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'vh-cshow-shop__tab';
        button.id = `${panel.id}-tab`;
        button.dataset.vhcTab = panel.id;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', panel.id);
        button.textContent = panel.dataset.categoryLabel;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', button.id);
        panel.tabIndex = 0;
        fragment.append(button);
      });

      this.tabs.replaceChildren(fragment);
      this.tabs.style.setProperty('--vh-cshow-tab-columns', String(Math.min(4, this.panels.length) || 1));
      this.tabs.setAttribute('role', 'tablist');
      this.tabs.hidden = this.panels.length === 0;

      const empty = this.querySelector('[data-vhc-empty]');
      if (empty) empty.hidden = this.panels.length !== 0;
      if (!this.panels.length) return;

      const configured = Math.max(0, (Number(this.dataset.defaultTab) || 1) - 1);
      const selected =
        this.panels.find((panel) => panel.id === this.activeId) ||
        this.panels[configured] ||
        this.panels[0];

      this.select(selected.id);
      this.setAttribute('data-ready', '');
    }

    select(id, moveFocus = false) {
      if (!this.panels?.some((panel) => panel.id === id)) return;

      this.activeId = id;
      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== id;
      });

      [...this.tabs.children].forEach((button) => {
        const active = button.dataset.vhcTab === id;
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
        if (active && moveFocus) button.focus({ preventScroll: true });

        if (active && this.dataset.tabsMobile === 'scroll' && this.tabs.scrollWidth > this.tabs.clientWidth) {
          const tabRect = button.getBoundingClientRect();
          const stripRect = this.tabs.getBoundingClientRect();
          if (tabRect.left < stripRect.left) this.tabs.scrollLeft -= stripRect.left - tabRect.left + 3;
          if (tabRect.right > stripRect.right) this.tabs.scrollLeft += tabRect.right - stripRect.right + 3;
        }
      });

      this.observeSceneSizes();
      this.observeRecommendationSizes();
      this.queueSceneFit();
      this.queueRecommendationLayout();
    }

    observeSceneSizes() {
      if (!this.sceneResizeObserver) return;
      this.sceneResizeObserver.disconnect();

      const activePanel = this.panels?.find((panel) => !panel.hidden);
      if (!activePanel) return;

      activePanel.querySelectorAll('[data-vhc-scene-contain]').forEach((scene) => {
        const media = scene.querySelector('.vh-cshow-featured__media');
        const content = scene.querySelector('.vh-cshow-featured__content');
        if (media) this.sceneResizeObserver.observe(media);
        if (content) this.sceneResizeObserver.observe(content);
      });
    }

    queueSceneFit() {
      if (this.sceneFitFrame || this.controller?.signal.aborted) return;

      this.sceneFitFrame = requestAnimationFrame(() => {
        this.sceneFitFrame = 0;
        if (!this.isConnected || this.controller?.signal.aborted) return;

        this.querySelectorAll('[data-vhc-scene-contain]').forEach((scene) => {
          const panel = scene.closest('[data-vhc-panel]');
          if (panel?.hidden) return;

          const media = scene.querySelector('.vh-cshow-featured__media');
          const content = scene.querySelector('.vh-cshow-featured__content');
          if (!media || !content) return;

          const imageBox = media.getBoundingClientRect();
          if (imageBox.width <= 0 || imageBox.height <= 0) return;

          const copyHeight = Math.max(content.scrollHeight, content.getBoundingClientRect().height);
          const fits = copyHeight <= imageBox.height - 16;

          if (scene.hasAttribute('data-vhc-fit-overlay') !== fits) {
            scene.toggleAttribute('data-vhc-fit-overlay', fits);
          }
        });

        this.queueRecommendationLayout();
      });
    }

    bindRecommendationTracks() {
      this.querySelectorAll('[data-vhc-products-track]').forEach((track) => {
        if (this.boundTracks.has(track)) return;
        this.boundTracks.add(track);

        track.addEventListener(
          'scroll',
          () => this.queueRecommendationLayout(),
          { passive: true, signal: this.controller.signal }
        );
      });
    }

    observeRecommendationSizes() {
      if (!this.layoutResizeObserver) return;
      this.layoutResizeObserver.disconnect();

      const activePanel = this.panels?.find((panel) => !panel.hidden);
      if (!activePanel) return;

      const featured = activePanel.querySelector('.vh-cshow-featured');
      const viewport = activePanel.querySelector('[data-vhc-products-viewport]');
      if (featured) this.layoutResizeObserver.observe(featured);
      if (viewport) this.layoutResizeObserver.observe(viewport);
    }

    queueRecommendationLayout() {
      if (this.recommendationFrame || this.controller?.signal.aborted) return;

      this.recommendationFrame = requestAnimationFrame(() => {
        this.recommendationFrame = 0;
        if (!this.isConnected || this.controller?.signal.aborted) return;

        this.querySelectorAll('[data-vhc-panel-ready]:not([hidden])').forEach((panel) => {
          const featured = panel.querySelector('.vh-cshow-featured');
          const shell = panel.querySelector('[data-vhc-products-shell]');
          const viewport = panel.querySelector('[data-vhc-products-viewport]');
          const track = panel.querySelector('[data-vhc-products-track]');

          if (!shell || !viewport || !track) return;

          if (this.desktopQuery.matches && featured && !panel.hidden) {
            const height = featured.getBoundingClientRect().height;
            if (height > 0) shell.style.height = `${Math.round(height)}px`;
          } else {
            shell.style.height = '';
          }

          this.updateRecommendationNavigation(panel);
        });
      });
    }

    pageStarts(panel) {
      const track = panel?.querySelector('[data-vhc-products-track]');
      if (!track) return [];

      if (this.desktopQuery.matches) {
        return [...track.querySelectorAll('[data-vhc-page-start-desktop]')];
      }

      if (this.dataset.mobileColumns === '1') {
        return [...track.querySelectorAll('[data-vhc-product-ready]')];
      }

      return [...track.querySelectorAll('[data-vhc-page-start-mobile]')];
    }

    nearestPageIndex(track, starts) {
      if (!starts.length) return 0;
      const current = track.scrollLeft;
      let nearest = 0;
      let distance = Infinity;

      starts.forEach((item, index) => {
        const delta = Math.abs(item.offsetLeft - current);
        if (delta < distance) {
          distance = delta;
          nearest = index;
        }
      });

      return nearest;
    }

    updateRecommendationNavigation(panel) {
      if (!panel || panel.hidden) return;

      const shell = panel.querySelector('[data-vhc-products-shell]');
      const viewport = panel.querySelector('[data-vhc-products-viewport]');
      const track = panel.querySelector('[data-vhc-products-track]');
      const previous = panel.querySelector('[data-vhc-products-prev]');
      const next = panel.querySelector('[data-vhc-products-next]');

      if (!shell || !viewport || !track || !previous || !next) return;

      const starts = this.pageStarts(panel);
      const overflow = starts.length > 1 && track.scrollWidth > viewport.clientWidth + 2;

      shell.toggleAttribute('data-vhc-overflow', overflow);
      previous.hidden = !overflow;
      next.hidden = !overflow;

      if (!overflow) {
        previous.disabled = true;
        next.disabled = true;
        return;
      }

      const index = this.nearestPageIndex(track, starts);
      previous.disabled = index <= 0;
      next.disabled = index >= starts.length - 1;
    }

    moveRecommendation(panel, direction) {
      if (!panel) return;

      const track = panel.querySelector('[data-vhc-products-track]');
      if (!track) return;

      const starts = this.pageStarts(panel);
      if (starts.length <= 1) return;

      const current = this.nearestPageIndex(track, starts);
      const nextIndex = Math.max(0, Math.min(starts.length - 1, current + direction));
      const target = starts[nextIndex];

      if (!target) return;

      track.scrollTo({
        left: target.offsetLeft,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    onKeydown(event) {
      const current = event.target.closest('[data-vhc-tab]');
      if (!current || !this.tabs?.contains(current)) return;

      const buttons = [...this.tabs.children];
      let index = buttons.indexOf(current);
      const rtl = getComputedStyle(this).direction === 'rtl';

      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = buttons.length - 1;
      else if (event.key === 'ArrowRight') index += rtl ? -1 : 1;
      else if (event.key === 'ArrowLeft') index += rtl ? 1 : -1;
      else return;

      event.preventDefault();
      index = (index + buttons.length) % buttons.length;
      this.select(buttons[index].dataset.vhcTab, true);
    }
  }

  customElements.define('vh-cshow-shop-v211', VHCollectionShop);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
